import { render, staticRenderFns } from "./PersonelDetail.vue?vue&type=template&id=65b8fb10&"
import script from "./PersonelDetail.vue?vue&type=script&lang=js&"
export * from "./PersonelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports